import { render, staticRenderFns } from "./productProcess.vue?vue&type=template&id=2a8b74e5"
import script from "./productProcess.vue?vue&type=script&lang=js"
export * from "./productProcess.vue?vue&type=script&lang=js"
import style0 from "./productProcess.vue?vue&type=style&index=0&id=2a8b74e5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports